import React, { Component } from 'react';

const withEscClose = (WrappedComponent) => {
  return class extends Component {
    componentDidMount = () => {
      document.addEventListener('keydown', this.onKeyPress);
      document.addEventListener('close-modal', this.close);
    }

    componentWillUnmount = () => {
      document.removeEventListener('keydown', this.onKeyPress);
      document.removeEventListener('close-modal', this.close);
    }

    onKeyPress = (event) => {
      const { keyCode } = event;
      if(keyCode === 27) {
        this.close();
      }
    };
    
    close = (event) => {
      this.props.onBackdropClick();
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default withEscClose;


// WEBPACK FOOTER //
// ./src/modules/common/components/withEscClose.js